import styled from 'styled-components';

export const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ContentArea = styled.div`
  max-width: ${({ theme }) => theme.metrics.contentMaxWidth};
  margin: 0 auto;
  padding: 24px ${({ theme }) => theme.metrics.paddingHorizontal};
  display: flex;
  flex: 1;
  width: 100%;
`;

export const MainContent = styled.main`
  flex: 1;
  min-width: 0;
`;
